import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { AlertComponent } from './alert/alert.component';
import { CwSearchComponent } from './side-nav/cw-search/cw-search.component';
import { CommitteeCalendarComponent } from './committee-calendar/committee-calendar.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AppRoutingModule } from './app-routing.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { EnvironmentService } from './environment/environment.service';

import { AuthService } from './auth/auth.service';
import { LoginComponent } from './login/login.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { DealsModule } from './deals/deals.module';

import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DataFormatService } from './services/data-format.service';
import { WildcardModule } from './wildcard-route/wildcard.module';
import { DocumentModule } from './document.module';
import { SharedModule } from './components/shared.module';
import { AddressAutocompleteComponent } from "./components/address-autocomplete/address-autocomplete.component";
import { DispositionsComponent } from './dispositions/dispositions.component';
import { DispositionsModule } from './dispositions/dispositions.module';
import { CompanyEventsModule } from './company-events/company-events.module';
import { MatRadioModule } from '@angular/material/radio';
import { ConsentsTrackingModule } from './consents-tracking/consents-tracking.module';
import { PipesModule } from './pipes/pipes.module';
import { DocumentTrackingModule } from './document-tracking/document-tracking.module';
import {FundsModule} from "./funds/funds.module";
import {EquityInstallmentModule} from "./equity-installment/equity-installment.module";
import provideApolloClient from "./graphql.module";
import { AngularEditorModule } from "@kolkov/angular-editor";
import {DueDiligenceModule} from "./due-diligence/due-diligence.module";
import {ContactsModule} from "./contacts/contacts.module";
import {PipelinesModule} from "./pipelines/pipelines.module";

@NgModule({ declarations: [
        AppComponent,
        SideNavComponent,
        AlertComponent,
        CwSearchComponent,
        CommitteeCalendarComponent,
        LoginComponent,
        UserAvatarComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        AppRoutingModule,
        DealsModule,
        ContactsModule,
        PipelinesModule,
        CompanyEventsModule,
        DispositionsModule,
        FundsModule,
        ConsentsTrackingModule,
        EquityInstallmentModule,
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatToolbarModule,
        MatRadioModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatCardModule,
        MatDialogModule,
        MatExpansionModule,
        MatMenuModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatGridListModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatTooltipModule,
        FullCalendarModule,
        DocumentModule,
        DocumentTrackingModule,
        PipesModule,
        WildcardModule,
        AngularEditorModule,
        DueDiligenceModule,
  ],
  providers: [
    EnvironmentService,
    AuthService,
    DataFormatService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ...provideApolloClient()
  ]
})

export class AppModule {}
